/*eslint-disable*/
import React, { useState, useRef, useEffect } from "react";
import Navbar from "../../Componenets/Navbar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Loader from "../../Componenets/Loader";
import "./styles.css";
const Index = () => {
  const [step, setStep] = useState(1);

  const handleNext = () => setStep(2);
  const handlePrev = () => setStep(1);

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    applicantType: "",
    contactName: "",
    contactOrganization: "",
    contactAddress: "",
    contactEmail: "",
    contactPhone: "",
    projectDescription: "",
    projectType: "",
    projectNeeds: "",
    projectLocation: "",
    primaryBeneficiaries: "",
    projectFor: "",
    totalCost: "",
    grantAmount: "",
    matchingFunds: "no",
    matchingDetails: "",
    otherFunding: "",
    startDate: "",
    completionDate: "",
    permitsRequired: "",
    previousDenial: "",
    denialReasons: "",
    evGrants: "",
    solarGrants: "",
  });

  const fieldRefs = useRef({});

  const handleCalculateClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "radio" ? (checked ? value : prev[name]) : value,
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "applicantType",
      "contactName",
      "contactOrganization",
      "contactAddress",
      "contactEmail",
      "contactPhone",
      "projectDescription",
      "projectType",
      "projectNeeds",
      "projectLocation",
      "primaryBeneficiaries",
      "projectFor",
      "totalCost",
      "grantAmount",
      "otherFunding",
      "startDate",
      "completionDate",
      "permitsRequired",
      "previousDenial",
      "evGrants",
      "solarGrants",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = "This field is required";
      }
    });

    // Email validation
    if (
      formData.contactEmail &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.contactEmail)
    ) {
      newErrors.contactEmail = "Please enter a valid email address";
    }

    // Phone number validation (basic)
    if (
      formData.contactPhone &&
      !/^[\d\s\-()+]{10,}$/.test(formData.contactPhone)
    ) {
      newErrors.contactPhone = "Please enter a valid phone number";
    }

    // If matching funds is yes, require matching details
    if (formData.matchingFunds === "yes" && !formData.matchingDetails) {
      newErrors.matchingDetails = "Please specify matching details";
    }

    // If previous denial is yes, require denial reasons
    if (formData.previousDenial === "yes" && !formData.denialReasons) {
      newErrors.denialReasons = "Please specify reasons for denial";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      console.log(formData);
      const obj = {
        who_is_applying: formData?.applicantType,
        name: formData?.contactName,
        organization: formData?.contactOrganization,
        address: formData?.address,
        email: formData?.contactEmail,
        phone: formData?.contactPhone,
        project: formData?.projectDescription,
        project_type: formData?.projectType,
        project_needs: formData?.projectNeeds,
        project_location: formData?.projectLocation,
        project_for: formData?.projectFor,
        total_project_cost: formData?.totalCost,
        project_grant_amount: formData?.grantAmount,
        project_contribution: formData?.matchingDetails,
        isFundingReceived: formData?.otherFunding,
        project_start_date: formData?.startDate,
        project_end_date: formData?.completionDate,
        is_permists_needed: formData?.permitsRequired,
        previous_grant_experience: formData?.previousDenial,
        interested_in_ev_grants: formData?.evGrants,
        interested_in_solar_grants: formData?.solarGrants,
      };
      setLoading(true);

      axios
        .post(
          "https://beta.ccalerc.com/api/create/betaventurerevgrant/lead",
          obj
        )
        .then((response) => {
          Swal.fire({
            title: "Thankyou!",
            text: "Our team will get back to you.",
            icon: "success",
          });
        })
        .catch((error) => {
          setErrors((prev) => ({
            ...prev,
            form: "Submission failed. Please try again.",
          }));
          Swal.fire({
            title: "Failed!",
            text: error.message,
            icon: "error",
          });
        })
        .finally(() => {
          setFormData({});
          setLoading(false);
        });

      axios
        .post(
          "https://leadcapturemails.ccalerc.com/api/leadcapturemails/sendVentureRevGrantEmail",
          obj
        )
        .then(() => {
          console.log("Email sent");
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      const firstErrorField = Object.keys(errors)[0];
      if (firstErrorField && fieldRefs.current[firstErrorField]) {
        fieldRefs.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  const setFieldRef = (name, element) => {
    if (element) {
      fieldRefs.current[name] = element;
    }
  };

  return (
    <div>
      <Navbar />
      <Loader isLoading={loading} />
      <section>
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12">
              <div className="form-container">
                <h3 className="text-center py-3">Grant Application Form</h3>

                <form onSubmit={handleSubmit}>
                  {/* Step 1 */}
                  {step === 1 && (
                    <div className="step" id="step1">
                      <div className="section-title">Applicant Information</div>

                      <div className="col-lg-12">
                        <div
                          className="mb-3"
                          ref={(el) => setFieldRef("applicantType", el)}
                        >
                          <label htmlFor="applicantType" className="form-label">
                            1. Who is applying for the grant?
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.applicantType ? "is-invalid" : ""
                            }`}
                            id="applicantType"
                            name="applicantType"
                            value={formData.applicantType}
                            onChange={handleChange}
                            placeholder="e.g., School, Nonprofit, Government Organization, Business, etc."
                          />
                          {errors.applicantType && (
                            <div className="invalid-feedback">
                              {errors.applicantType}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="mb-0">
                        <label className="form-label">
                          2. Contact Information
                        </label>
                        <div className="row">
                          <div
                            className="col-md-6 mb-0"
                            ref={(el) => setFieldRef("contactName", el)}
                          >
                            <input
                              type="text"
                              className={`form-control w-100 ${
                                errors.contactName ? "is-invalid" : ""
                              }`}
                              name="contactName"
                              value={formData.contactName}
                              onChange={handleChange}
                              placeholder="Name"
                            />
                            {errors.contactName && (
                              <div className="invalid-feedback">
                                {errors.contactName}
                              </div>
                            )}
                          </div>
                          <div
                            className="col-md-4 mb-2"
                            ref={(el) => setFieldRef("contactOrganization", el)}
                          >
                            <input
                              type="text"
                              className={`form-control w-100 ${
                                errors.contactOrganization ? "is-invalid" : ""
                              }`}
                              name="contactOrganization"
                              value={formData.contactOrganization}
                              onChange={handleChange}
                              placeholder="Organization"
                            />
                            {errors.contactOrganization && (
                              <div className="invalid-feedback">
                                {errors.contactOrganization}
                              </div>
                            )}
                          </div>

                          <div
                            className="col-md-4 mb-2"
                            ref={(el) => setFieldRef("contactAddress", el)}
                          >
                            <input
                              type="text"
                              className={`form-control w-100 ${
                                errors.contactAddress ? "is-invalid" : ""
                              }`}
                              name="contactAddress"
                              value={formData.contactAddress}
                              onChange={handleChange}
                              placeholder="Address"
                            />
                            {errors.contactAddress && (
                              <div className="invalid-feedback">
                                {errors.contactAddress}
                              </div>
                            )}
                          </div>
                          <div
                            className="col-md-4 mb-2"
                            ref={(el) => setFieldRef("contactEmail", el)}
                          >
                            <input
                              type="email"
                              className={`form-control w-100 ${
                                errors.contactEmail ? "is-invalid" : ""
                              }`}
                              name="contactEmail"
                              value={formData.contactEmail}
                              onChange={handleChange}
                              placeholder="Email"
                            />
                            {errors.contactEmail && (
                              <div className="invalid-feedback">
                                {errors.contactEmail}
                              </div>
                            )}
                          </div>
                          <div
                            className="col-md-4"
                            ref={(el) => setFieldRef("contactPhone", el)}
                          >
                            <input
                              type="tel"
                              className={`form-control w-100 ${
                                errors.contactPhone ? "is-invalid" : ""
                              }`}
                              name="contactPhone"
                              value={formData.contactPhone}
                              onChange={handleChange}
                              placeholder="Phone"
                            />
                            {errors.contactPhone && (
                              <div className="invalid-feedback">
                                {errors.contactPhone}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <div
                            className="mb-0"
                            ref={(el) => setFieldRef("projectDescription", el)}
                          >
                            <label
                              htmlFor="projectDescription"
                              className="form-label"
                            >
                              3. What is the project?
                            </label>
                            <textarea
                              className={`form-control ${
                                errors.projectDescription ? "is-invalid" : ""
                              }`}
                              id="projectDescription"
                              name="projectDescription"
                              value={formData.projectDescription}
                              onChange={handleChange}
                              rows="1"
                              placeholder="Provide a brief description of the project"
                            ></textarea>
                            {errors.projectDescription && (
                              <div className="invalid-feedback">
                                {errors.projectDescription}
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          className="col-md-6"
                          ref={(el) => setFieldRef("projectLocation", el)}
                        >
                          <label
                            htmlFor="projectLocation"
                            className="form-label"
                          >
                            4. Is the project located in:
                          </label>
                          <select
                            className={`form-select ${
                              errors.projectLocation ? "is-invalid" : ""
                            }`}
                            id="projectLocation"
                            name="projectLocation"
                            value={formData.projectLocation}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select project scope
                            </option>
                            <option value="Rural Area">Rural Area</option>
                            <option value="Urban Area">Urban Area</option>
                            <option value="Suburban Area">Suburban Area</option>
                          </select>
                          {errors.projectLocation && (
                            <div className="invalid-feedback">
                              {errors.projectLocation}
                            </div>
                          )}
                        </div>
                        <div className="col-md-12">
                          <div className="row mb-0">
                            <div
                              className="col-md-12"
                              ref={(el) => setFieldRef("projectType", el)}
                            >
                              <label
                                htmlFor="projectType"
                                className="form-label"
                              >
                                5. Is this a new project or a
                                continuation/expansion of an existing one?
                              </label>
                              <select
                                className={`form-select ${
                                  errors.projectType ? "is-invalid" : ""
                                }`}
                                id="projectType"
                                name="projectType"
                                value={formData.projectType}
                                onChange={handleChange}
                              >
                                <option value="" disabled>
                                  Select project type
                                </option>
                                <option value="New Project">New Project</option>
                                <option value="Continuation">
                                  Continuation
                                </option>
                                <option value="Expansion">Expansion</option>
                              </select>
                              {errors.projectType && (
                                <div className="invalid-feedback">
                                  {errors.projectType}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div
                            className="mb-0"
                            ref={(el) => setFieldRef("projectNeeds", el)}
                          >
                            <label
                              htmlFor="projectNeeds"
                              className="form-label"
                            >
                              6. Describe the specific needs or problems this
                              project will address:
                            </label>
                            <textarea
                              className={`form-control ${
                                errors.projectNeeds ? "is-invalid" : ""
                              }`}
                              id="projectNeeds"
                              name="projectNeeds"
                              value={formData.projectNeeds}
                              onChange={handleChange}
                              rows="1"
                              placeholder="Explain the challenges or gaps your project aims to solve"
                            ></textarea>
                            {errors.projectNeeds && (
                              <div className="invalid-feedback">
                                {errors.projectNeeds}
                              </div>
                            )}
                          </div>
                        </div>

                        <div
                          className="col-md-12"
                          ref={(el) => setFieldRef("primaryBeneficiaries", el)}
                        >
                          <label
                            htmlFor="primaryBeneficiaries"
                            className="form-label"
                          >
                            7. Who will be the primary beneficiaries of this
                            project?
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.primaryBeneficiaries ? "is-invalid" : ""
                            }`}
                            id="primaryBeneficiaries"
                            name="primaryBeneficiaries"
                            value={formData.primaryBeneficiaries}
                            onChange={handleChange}
                            placeholder="e.g., Youth, Elderly, General Public, Specific Group"
                          />
                          {errors.primaryBeneficiaries && (
                            <div className="invalid-feedback">
                              {errors.primaryBeneficiaries}
                            </div>
                          )}
                        </div>
                        <div
                          className="col-md-12"
                          ref={(el) => setFieldRef("projectFor", el)}
                        >
                          <label htmlFor="projectFor" className="form-label">
                            8. Is the project for:
                          </label>
                          <select
                            className={`form-select ${
                              errors.projectFor ? "is-invalid" : ""
                            }`}
                            id="projectFor"
                            name="projectFor"
                            value={formData.projectFor}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select project scope
                            </option>
                            <option value="Public/Community">
                              Public/Community
                            </option>
                            <option value="Private/Individual">
                              Private/Individual
                            </option>
                            <option value="Both">Both</option>
                          </select>
                          {errors.projectFor && (
                            <div className="invalid-feedback">
                              {errors.projectFor}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-between mt-4">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handlePrev} // Add this onClick handler
                        >
                          Previous
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleNext}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Step 2 */}
                  {step === 2 && (
                    <div className="step" id="step2">
                      <div className="section-title">Financial Information</div>

                      <div className="row mb-0">
                        <div
                          className="col-md-6"
                          ref={(el) => setFieldRef("totalCost", el)}
                        >
                          <label htmlFor="totalCost" className="form-label">
                            9. What is the total estimated cost of the project?
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.totalCost ? "is-invalid" : ""
                            }`}
                            id="totalCost"
                            name="totalCost"
                            value={formData.totalCost}
                            onChange={handleChange}
                            placeholder="$"
                          />
                          {errors.totalCost && (
                            <div className="invalid-feedback">
                              {errors.totalCost}
                            </div>
                          )}
                        </div>
                        <div
                          className="col-md-6"
                          ref={(el) => setFieldRef("grantAmount", el)}
                        >
                          <label htmlFor="grantAmount" className="form-label">
                            10. What grant amount are you requesting?
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.grantAmount ? "is-invalid" : ""
                            }`}
                            id="grantAmount"
                            name="grantAmount"
                            value={formData.grantAmount}
                            onChange={handleChange}
                            placeholder="$"
                          />
                          {errors.grantAmount && (
                            <div className="invalid-feedback">
                              {errors.grantAmount}
                            </div>
                          )}
                        </div>
                        <div
                          className="mb-0 col-lg-12"
                          ref={(el) => setFieldRef("matchingFunds", el)}
                        >
                          <label className="form-label">
                            11. Are you contributing any matching funds or
                            in-kind contributions?
                          </label>
                          <div className="d-flex gap-4">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="matchingFunds"
                                id="matchingYes"
                                value="yes"
                                checked={formData.matchingFunds === "yes"}
                                onChange={handleChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="matchingYes"
                              >
                                Yes
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="matchingFunds"
                                id="matchingNo"
                                value="no"
                                checked={formData.matchingFunds === "no"}
                                onChange={handleChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="matchingNo"
                              >
                                No
                              </label>
                            </div>
                          </div>
                          {formData.matchingFunds === "yes" && (
                            <div
                              ref={(el) => setFieldRef("matchingDetails", el)}
                            >
                              <input
                                type="text"
                                className={`form-control mt-2 ${
                                  errors.matchingDetails ? "is-invalid" : ""
                                }`}
                                id="matchingDetails"
                                name="matchingDetails"
                                value={formData.matchingDetails}
                                onChange={handleChange}
                                placeholder="If Yes, please specify the percentage or amount"
                              />
                              {errors.matchingDetails && (
                                <div className="invalid-feedback">
                                  {errors.matchingDetails}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div
                          className="mb-0 col-lg-12"
                          ref={(el) => setFieldRef("otherFunding", el)}
                        >
                          <label htmlFor="otherFunding" className="form-label">
                            12. Have you received or applied for funding from
                            other sources for this project?
                          </label>
                          <select
                            className={`form-select ${
                              errors.otherFunding ? "is-invalid" : ""
                            }`}
                            id="otherFunding"
                            name="otherFunding"
                            value={formData.otherFunding}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select option
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                          {errors.otherFunding && (
                            <div className="invalid-feedback">
                              {errors.otherFunding}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* <!-- Project Timeline --> */}
                      <div className="section-title">Project Timeline</div>

                      <div className="row mb-0">
                        <div
                          className="col-md-6"
                          ref={(el) => setFieldRef("startDate", el)}
                        >
                          <label htmlFor="startDate" className="form-label">
                            13. What is the estimated project start date?
                          </label>
                          <input
                            type="date"
                            className={`form-control ${
                              errors.startDate ? "is-invalid" : ""
                            }`}
                            id="startDate"
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleChange}
                          />
                          {errors.startDate && (
                            <div className="invalid-feedback">
                              {errors.startDate}
                            </div>
                          )}
                        </div>
                        <div
                          className="col-md-6"
                          ref={(el) => setFieldRef("completionDate", el)}
                        >
                          <label
                            htmlFor="completionDate"
                            className="form-label"
                          >
                            14. What is the estimated completion date?
                          </label>
                          <input
                            type="date"
                            className={`form-control ${
                              errors.completionDate ? "is-invalid" : ""
                            }`}
                            id="completionDate"
                            name="completionDate"
                            value={formData.completionDate}
                            onChange={handleChange}
                          />
                          {errors.completionDate && (
                            <div className="invalid-feedback">
                              {errors.completionDate}
                            </div>
                          )}
                        </div>
                        <div
                          className="col-md-12"
                          ref={(el) => setFieldRef("permitsRequired", el)}
                        >
                          <label
                            htmlFor="permitsRequired"
                            className="form-label"
                          >
                            15. Are there any permits, approvals, or site
                            control requirements needed before starting?
                          </label>
                          <select
                            className={`form-select ${
                              errors.permitsRequired ? "is-invalid" : ""
                            }`}
                            id="permitsRequired"
                            name="permitsRequired"
                            value={formData.permitsRequired}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select option
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                          {errors.permitsRequired && (
                            <div className="invalid-feedback">
                              {errors.permitsRequired}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="section-title">
                        Previous Grant Experience:
                      </div>
                      <div className="row">
                        <div
                          className="mb-0 col-md-12"
                          ref={(el) => setFieldRef("previousDenial", el)}
                        >
                          <label
                            htmlFor="previousDenial"
                            className="form-label"
                          >
                            16. Have you applied for grants before but been
                            denied?
                          </label>
                          <select
                            className={`form-select ${
                              errors.previousDenial ? "is-invalid" : ""
                            }`}
                            id="previousDenial"
                            name="previousDenial"
                            value={formData.previousDenial}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select option
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                          {formData.previousDenial === "yes" && (
                            <div ref={(el) => setFieldRef("denialReasons", el)}>
                              <textarea
                                className={`form-control mt-2 ${
                                  errors.denialReasons ? "is-invalid" : ""
                                }`}
                                id="denialReasons"
                                name="denialReasons"
                                value={formData.denialReasons}
                                onChange={handleChange}
                                rows="2"
                                placeholder="If Yes, what were the primary reasons or barriers you ran into?"
                              />
                              {errors.denialReasons && (
                                <div className="invalid-feedback">
                                  {errors.denialReasons}
                                </div>
                              )}
                            </div>
                          )}
                          {errors.previousDenial && (
                            <div className="invalid-feedback">
                              {errors.previousDenial}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="section-title">
                        Additional Grant Interests:
                      </div>
                      <div className="row">
                        <div
                          className="col-md-12"
                          ref={(el) => setFieldRef("evGrants", el)}
                        >
                          <label htmlFor="evGrants" className="form-label">
                            17. Are you interested in EV grants for charging
                            stations, buses, or other electric vehicles?
                          </label>
                          <select
                            className={`form-select ${
                              errors.evGrants ? "is-invalid" : ""
                            }`}
                            id="evGrants"
                            name="evGrants"
                            value={formData.evGrants}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select option
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                          {errors.evGrants && (
                            <div className="invalid-feedback">
                              {errors.evGrants}
                            </div>
                          )}
                        </div>
                        <div
                          className="col-md-12"
                          ref={(el) => setFieldRef("solarGrants", el)}
                        >
                          <label htmlFor="solarGrants" className="form-label">
                            18. Are you interested in solar grants?
                          </label>
                          <select
                            className={`form-select ${
                              errors.solarGrants ? "is-invalid" : ""
                            }`}
                            id="solarGrants"
                            name="solarGrants"
                            value={formData.solarGrants}
                            onChange={handleChange}
                          >
                            <option value="" disabled>
                              Select option
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                            <option value="Not Sure">Not Sure</option>
                          </select>
                          {errors.solarGrants && (
                            <div className="invalid-feedback">
                              {errors.solarGrants}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-between mt-4">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handlePrev} // This was missing
                        >
                          Previous
                        </button>
                        <button
                          className="btn btn-primary grant_form_btn"
                          type="submit"
                        >
                          Submit Application
                        </button>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Index;
